import React from 'react';
import Select from 'react-select';

const VersionDetail = (props) => {
   const {changeHandler,addonDetail,addonList,valueChangeHandler} = props;
   const {version,price,discount,description,feature,dependent_id} = addonDetail.version_details;
   
	return (
		<div className="tab-pane fade" id="tab2">
            <div className="row">
               <div className="col-6 ">
                  <div className="form-group">
                     <label>Version Name</label>
                     <input type="text" className="form-control mandatory" value={version} name="version" onChange={changeHandler} />
                  </div>
               </div> 
                <div className="col-6 ">
                  <div className="form-group">
                     <label> Dependency  </label>
                     {/*<select className="form-control" name="dependent_id" onChange={changeHandler} value={dependent_id}>
                        <option value="">None</option>
                        {addonList && addonList.length>0 ? 
                           addonList.map((item,ind) => {
                              return <option key={ind} value={item.id}>{item.name}</option>
                           })
                        : null}
                     </select>*/}
                     <Select
                        classNamePrefix="form-control"
                        value={dependent_id}
                        isMulti
                        onChange={e=>valueChangeHandler(e,"dependent_id","version")}
                        options={addonList}
                     />
                  </div>
               </div>
               <div className="col-6 ">
                  <div className="form-group">
                     <label> Price  </label>
                     <input type="text" className="form-control" value={price} name="price" onChange={changeHandler} />
                  </div>
               </div>
               <div className="col-6 ">
                  <div className="form-group">
                     <label> Discount  </label>
                     <input type="text" className="form-control" value={discount} name="discount" onChange={changeHandler} />
                  </div>
               </div>
              
            </div>

            <div className="row">
               <div className="col-6">
                  <div className="form-group">
                     <label>Short Description</label>
                     <textarea className="form-control" value={description} name="description" onChange={changeHandler}></textarea>
                  </div>
               </div>
               <div className="col-6">
                  <div className="form-group">
                     <label>Features</label>
                     <textarea className="form-control" value={feature} name="feature" onChange={changeHandler}></textarea>
                  </div>
               </div>
            </div>
         </div>
	)
}

export default VersionDetail;